import "../scss/page.scss";

import "../scss/joboffer.scss";